export default {
  login_mfa: {
    title: '@:login.title',
    message: 'Se ha enviado un SMS con un código de verificación a tu número de teléfono registrado.\nIngresa el código de verificación y pulsa el botón de inicio de sesión.\nEl tiempo de caducidad es de 5 minutos',
    button_submit: '@:login.login',
    button_resend: 'Reenviar código de verificación',
    alert_success: 'Se ha reenviado el código de verificación.',
    alert_error: 'El reenvío del código de verificación ha fallado.',
    error: '@:common.error.code_9999',
    no_phone_number_message: 'No se puede utilizar la autenticación por SMS ya que el número de teléfono del usuario no está registrado.\n\nContacte con el administrador de su empresa para añadir su número de teléfono.',
  },
}
